import { type MoveEvent, koSquare } from '@chessbut/engine';
import type { VariantUi } from './ui.ts';

const FLIP = '/art/flip.svg';
const flipped = (e: MoveEvent) => e.t === 'add' && e.cause === 'flip';

export const flipUi: VariantUi = {
  heroImage: FLIP,
  peek: [{}, { image: '/art/bR.svg', threat: true }, {}, {}, {}, {}, {}, { image: '/art/wB.svg' }, {}],

  decorations(pos) {
    const ko = koSquare(pos);
    return ko >= 0 ? [{ kind: 'mark', sq: ko, tone: 'info', hint: true }] : [];
  },

  twist(pos) {
    return koSquare(pos) >= 0
      ? { text: 'Captured pieces join your side. The one that just switched can’t switch back yet.' }
      : { text: 'Captured pieces join your side, and your piece stays put' };
  },

  eventSound(e) {
    return e.t === 'fx' && e.kind === 'flip' ? 'flip' : null;
  },

  moveBadge(rec) {
    const e = rec.events.find(flipped);
    return e && e.t === 'add' ? { icon: FLIP, victim: e.piece, title: 'Switched sides' } : null;
  },
};
